// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3o3qj","actions":"GroupTable_actions__2RIL8","deleteModalFooter":"GroupTable_deleteModalFooter__28D2i"};